import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from 'reactstrap';
import Base from '../../components/base/Base';
import { CareerStatus } from '../../components/careerSelector/academicInformationTypes';
import CareerSelector from '../../components/careerSelector/CareerSelector';
import TopBar from '../../components/topBar/TopBar';
import CoursesLoader from './parts/CourseLoader';
import CoursesList from './parts/CoursesList';
import { PendingSurveysNotification } from './parts/PendingSurveysNotification';
import StudentStatusLoader from './parts/StudentStatusLoader';

export default function MyCourses() {
  const { t } = useTranslation();
  const [pendingSurveys, setPendingSurveys] = useState<boolean>(false);

  return (
    <Base>
      <TopBar title={t(`myCourses.topBarTitle`)} />
      <Card className="p-4 mx-3">
        <CareerSelector allowedStatus={[CareerStatus.Regular]}>
          <PendingSurveysNotification
            showPendingNotification={pendingSurveys}
          />
          <StudentStatusLoader>
            {(statusToEnroll) => (
              <CoursesLoader>
                {(courses, showPendingNotification) => {
                  setPendingSurveys(showPendingNotification);
                  return (
                    <CoursesList
                      courses={courses}
                      errorLoading={false}
                      statusToEnroll={statusToEnroll}
                    />
                  );
                }}
              </CoursesLoader>
            )}
          </StudentStatusLoader>
        </CareerSelector>
      </Card>
    </Base>
  );
}
